export default __webpack_public_path__ + "static/meshery-logo-shadow-31f973a6d26622a1ce1dedba0b889cfa.webp";